module.exports = __webpack_public_path__ + "static/9-920157069b0a8616677874105b0de92c.jpeg";